// *******************************************************************************
// 1.0 - Range Slider
// *******************************************************************************
const setDrinkCalculator = debounce((calculator, numberOfDrinks) => {
  const currentValue = document.querySelector('.ingredient-calculator__price-amount input').value;
  const axiosData = new FormData();
  axiosData.append('action', 'bundleCalculator');
  axiosData.append('recipe', localData.id);
  axiosData.append('number_of_drinks', Number(numberOfDrinks));
  axios.post(localData.apiURL, axiosData).then((response) => {
    const { data } = response.data;
    data.items.forEach((item) => {
      const productCard = calculator.querySelector(`.product-small-card[data-product-id="${item.product_id}"]`);
      if (productCard && item.bottles) {
        productCard.querySelector('input').value = item.bottles;

        document.querySelectorAll('.quantity-counter').forEach((el) => {
          const inputElem = el.querySelector('.quantity-counter__input');
          const minusButton = el.querySelector('.quantity-counter__button--remove');
          const currentVal = parseInt(inputElem.value, 10);
          if (currentVal > 1) minusButton.classList.remove('is-disabled');
        });
      }
    });
    calculator.querySelector('.ingredient-calculator__price-label p').innerHTML = data.price_text;
    calculator.querySelector('.ingredient-calculator__price-amount p').innerHTML = data.price;
    document.querySelector('.ingredient-calculator__price-amount input')?.setAttribute('value', data.price);
    animateNumbersValue(currentValue, '.ingredient-calculator__price');
  });
}, 100);

const rangeSliderElements = document.querySelectorAll('.range-slider__input');
rangeSliderElements.forEach((el) => {
  const rangeFrom = parseInt(el.getAttribute('data-from'), 10);
  const rangeTo = parseInt(el.getAttribute('data-to'), 10);
  const rangeMinNum = parseInt(el.getAttribute('data-min'), 10);
  const rangeMaxNum = parseInt(el.getAttribute('data-max'), 10);

  const parentEle = el.closest('.range-slider');
  const rangeStartInput = parentEle.querySelector('.range-slider__start-range');
  const rangeEndInput = parentEle.querySelector('.range-slider__end-range');
  const quantityEle = parentEle.classList.contains('range-slider--secondary');
  const animatedInput = parentEle.querySelector('[data-animated-price-input]');

  const rangeValues = [rangeStartInput, rangeEndInput];

  noUiSlider.create(el, {
    start: quantityEle ? rangeTo : [rangeFrom, rangeTo],
    connect: quantityEle ? [true, false] : [false, true, false],
    tooltips: quantityEle ? [false] : [true, true],
    behaviour: quantityEle ? 'snap' : 'tap',
    step: 1,
    range: {
      min: rangeMinNum,
      max: rangeMaxNum,
    },
    format: quantityEle
      ? {
          to: (value) => Math.round(value),
          from: (value) => Number(value),
        }
      : wNumb({
          mark: ',',
          thousand: '.',
          decimals: 0,
          suffix: '€',
        }),
  });

  // Helper function to prevent event propagation
  const stopPropagation = (event) => {
    event.stopPropagation();
  };

  const makeTooltip = (i, slider) => {
    const tooltip = document.createElement('div');
    const input = document.createElement('input');

    tooltip.className = 'noUi-tooltip';
    input.className = 'price-ui-filter';
    tooltip.appendChild(input);

    // On change, set the slider
    input.addEventListener('change', (element) => {
      const values = [null, null];
      values[i] = element.target.value;
      slider.noUiSlider.set(values);
    });

    // Prevent clicks on the tooltip input from affecting the slider
    ['mousedown', 'touchstart', 'pointerdown', 'MSPointerDown'].forEach((event) => {
      input.addEventListener(event, stopPropagation, { passive: true });
    });

    // Find the lower/upper slider handle and insert the tooltip
    slider.querySelector(i ? '.noUi-handle-upper' : '.noUi-handle-lower').appendChild(tooltip);

    return input;
  };

  if (!quantityEle) el.tooltipInputs = [makeTooltip(0, el), makeTooltip(1, el)];

  el.noUiSlider.on('slide', (values, handle) => {
    animatedInput?.setAttribute('value', Number(values[handle] || 0));
  });

  let firstLoad = true;

  el.noUiSlider.on('update', (values, handle) => {
    if (quantityEle) {
      rangeEndInput.value = values[handle];

      if (firstLoad) {
        animatedInput?.setAttribute('value', Number(values[handle] || 0));
        firstLoad = false;
      }
    } else {
      rangeValues[handle].value = values[handle];
    }
    const calculator = document.querySelector('.ingredient-calculator, .sc-product-calculator');
    if (calculator) {
      if (calculator.classList.contains('sc-product-calculator')) {
        const numberOfDrinks = Number(calculator.dataset.numberOf || 1);
        const currentValue = Number(values[handle] || 0);
        calculator.querySelector('.quantity-counter__input').value = Math.ceil(currentValue / numberOfDrinks);
        document.querySelectorAll('.quantity-counter').forEach((el) => {
          const inputElem = el.querySelector('.quantity-counter__input');
          const minusButton = el.querySelector('.quantity-counter__button--remove');
          const currentVal = parseInt(inputElem.value, 10);
          if (currentVal > 1) minusButton.classList.remove('is-disabled');
        });
      } else {
        setDrinkCalculator(calculator, values[handle]);
      }
    }
    if (!quantityEle) el.tooltipInputs[handle].value = values[handle];
  });
});
